module.exports = __webpack_public_path__ + "img/service-other-content-update@3x.a9f1440d.png";